import { Component, AfterViewInit, ViewChild, ElementRef, Input, OnInit, OnDestroy, ChangeDetectorRef, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { ComputerService } from '@toro/common/shared/services/computer/computer.service';
import { ComputingParameter } from '@toro/common/shared/models/computing-parameter/computing-parameter.model';
import { StocksExchangeCheckoutAction } from '../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';
import { StockCheckoutType } from '@toro/common/shared/models/stocks-exchange/stock-checkout.model';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { KeyStocks } from '@toro/common/shared/enum/key-stocks/key-stocks.enum';
import { Subscription, Subject } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { StockCardsComponent } from '../../../../partials/stock-cards/stock-cards.component';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { RolesUser } from '@toro/common/shared/enum/roles-user.enum';
import { DialogGraphicComponent } from '../../../dialogs/dialog-graphic/dialog-graphic.component';
import { OverlaySimpleComponent } from '@toro/common/shared/components/dialogs/overlay-simple/overlay-simple.component';
import { ResearchAdviceLite } from '@toro/common/shared/models/research/research-opportunity.model';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';
import { InstrumentLite } from '@toro/common/shared/models/quote/instrument-lite.model';
import { TrackOriginEnum } from '@toro/common/shared/enum/segment/segment-origin.enum';
import { StorageService } from '@toro/common/shared/services/storage.service';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { CheckoutWrapperComponent } from '../../../../shared/panels/checkout/wrapper/checkout-wrapper.component';
import { filter, map } from 'rxjs/operators';
import { BrokerageModel } from '@toro/common/shared/enum/billing/brokerage-model.enum';

@AutoUnsubscribe()
@Component({
    selector: 'opportunity-card',
    templateUrl: './opportunity-card.component.html',
    styleUrls: ['./opportunity-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class OpportunityCardComponent extends StockCardsComponent implements AfterViewInit, OnInit, OnDestroy {

    @ViewChild('elementCard', {static: true}) public elementCard: ElementRef;
    @Output() public onLastItemLoaded: Subject<boolean> = new Subject<boolean>();
    @Output() public profitPotencialCalculate: Subject<any> = new Subject<any>();
    @Input('stayActive') public stayActive: boolean = false;
    @Input('isAnalysis') public isAnalysis: boolean = false;
    @Input('aboutCompanyText') public aboutCompanyText: string = '';
    @Input('categoryName') public categoryName: string;

    // Para contação
    @Input() public needQuote: boolean = true;

    @Input('lastItemLoaded') set lastItemLoaded(value: boolean) {
        if (value) this.onLastItemLoaded.next(true);
    }

    get symbol(): string {
        return this.stockDetails.symbolID || this.stockDetails.SymbolID;
    }
    get isDayTrade(): boolean {
        return this.stockDetails.isDayTrade !== undefined ? this.stockDetails.isDayTrade : this.stockDetails.IsDayTrade;
    }

    get marketType(): OrderMarketTypeEnum {
        return this.instrument.typeMarket;
    }

    get instumentName(): string {
        return this.instrument.description;
    }

    get isPlanned(): boolean {
        return (this.stockDetails.strategyID || this.stockDetails.StrategyID) ? true : false;
    }

    public profitPotential: any = 0;
    public minimumPriceToInvest: any = 0;
    public quote: any = null;
    public instrument: InstrumentLite = null;
    public logo: string = '';
    public stress: any = null;
    public secondaryStress: any = null;
    public sideEnum: any = OrderSideEnum;
    public pTaxValue: number = 0;
    public calculateParams: ComputingParameter = null;
    public marketScenario: number = null;
    public calculateScenario: number = null;
    public unitPrice: number = null;
    public gainPrice: number = null;
    public lossPrice: number = null;
    public isFuture: boolean = false;
    public isPtax: boolean = false;
    public isLogged: boolean = false;
    public isMobile: boolean;

    public userProfile: any = null;

    private userSubscription: Subscription;
    private authSubscription: Subscription;
    private quoteSubscription: Subscription;
    private instrumentSubscription: Subscription;
    private stressSubscription: Subscription;
    private pTaxSubscription: Subscription;
    private disposableSubscriptions: Subscription[] = [];
    private usingZeroModel: boolean = false;

    constructor(
        protected router: Router,
        protected dialogServices: DialogsService,
        protected store: Store<AppState>,
        private computeService: ComputerService,
        protected changeDetectorRef: ChangeDetectorRef,
        private settingService: SettingsService,
        private utilitiesService: UtilitiesService,
    ) {
        super(router, dialogServices, store, changeDetectorRef);
    }

    public ngOnInit() {

        this.calculateByBase(this.stockDetails);

        // Recupera dados do authentication
        this.userSubscription = this.store.select((state) => state.authentication.currentUser).pipe(
            filter((user: any) => user ? true : false)
        )
            .subscribe(() => {
                this.isLogged = true;
            });

        // Recupera os dados do perfil do usuário
        this.userSubscription = this.store.select((state) => state.userProfile.user).pipe(
            filter((user: any) => user && user.profile ? true : false)
        )
            .subscribe((data) => {
                this.userProfile = data.profile;
            });

        // Recupera os dados da cotação
        this.quoteSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.quote).pipe(
            filter((item) => this.stockDetails && item[this.symbol]),
            map((item) => item[this.symbol])
        )
            .subscribe((data) => {
                this.quote = data;
                const price = this.quote.PriceLastTrade || this.quote.OpeningPrice || this.quote.ClosingPricePreviousDay;
                if (price != null)
                    this.unitPrice = price;
                this.calculateResources();
                this.minimumPriceToInvest = this.calculateMinimumPriceToInvest();
                this.profitPotential = this.calculateProfitPotential();
            });

        // Recupera os dados de cotação do Dolar
        this.pTaxSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.quote).pipe(
            filter((item) => this.stockDetails && item[KeyStocks.DolPtax]),
            map((item) => item[KeyStocks.DolPtax])
        )
            .subscribe((data) => {
                this.pTaxValue = data.PriceLastTrade || data.OpeningPrice || data.ClosingPricePreviousDay;
                this.calculateResources();
                this.minimumPriceToInvest = this.calculateMinimumPriceToInvest();
                this.profitPotential = this.calculateProfitPotential();
            });

        this.bindBillingSubscriptions();

        this.isMobile = this.utilitiesService.isMobile();

        if (this.needQuote) {
            this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.symbol });
        }

    }

    public ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    public bindBillingSubscriptions(){
        this.disposableSubscriptions.push(
            this.store.select((state) => state.billing)
                .subscribe((billing: any) => {
                    if (billing && billing.brokerageModel.type) {
                        this.usingZeroModel = (billing.brokerageModel.type === BrokerageModel.Zero);
                    }
                }),
        )
    }

    /**
     * Retorna o valor do potencial de lucro
     */
    public calculateProfitPotential() {
        this.lossPrice = this.calculateGainLossPrice('loss');
        this.gainPrice = this.calculateGainLossPrice('gain');
        this.fillCalculateParams();
        if (!this.calculateParams) return;
        const profitPotential = this.computeService.computeProfitPotential(
            this.marketScenario,
            this.calculateScenario,
            this.calculateParams,
            this.gainPrice,
            this.isFuture,
            this.symbol,
        );
        this.profitPotencialCalculate.next(profitPotential);
        return profitPotential;
    }

    /**
     * Calcula o valor minimo para investir
     */
    public calculateMinimumPriceToInvest() {
        this.lossPrice = this.calculateGainLossPrice('loss');
        this.fillCalculateParams();
        if (!this.calculateParams) return;
        return this.computeService.calculate(this.marketScenario, this.calculateScenario, this.calculateParams) || 0;
    }

    /**
     * Calcula o valor de ganho e perda
     * @param type ('gain'|'loss') tipo do calcula, se pra gain ou loss
     */
    public calculateGainLossPrice(type: string) {
        const side = this.stockDetails.side;
        const valueStop = this.stockDetails.stop;
        const valueGain = this.stockDetails.goal;
        if (this.isFuture) {
            if (side === OrderSideEnum.Compra) {
                if (type === 'gain') return this.unitPrice + valueGain;
                if (type === 'loss') return this.unitPrice - valueStop;
            } else {
                if (type === 'gain') return this.unitPrice - valueGain;
                if (type === 'loss') return this.unitPrice + valueStop;
            }
        } else {
            if (side === OrderSideEnum.Compra) {
                if (type === 'gain') return this.unitPrice * (1 + (valueGain / 100));
                if (type === 'loss') return this.unitPrice * (1 - (valueStop / 100));
            } else {
                if (type === 'gain') return this.unitPrice * (1 - (valueGain / 100));
                if (type === 'loss') return this.unitPrice * (1 + (valueStop / 100));
            }
        }
    }

    /**
     * Preenche os dados do calculateParam
     */
    public fillCalculateParams() {
        if (!this.instrument || !this.stress) return;
        this.marketScenario = this.computeService.computeMarketScenario(this.marketType, this.isPtax);
        this.calculateScenario = this.computeService.computeCalculatingScenario(
            (this.stockDetails.side || this.stockDetails.Side) === OrderSideEnum.Compra,
            this.isDayTrade,
            true,
        );
        this.calculateParams = new ComputingParameter(
            this.instrument.standardLot,
            this.unitPrice,
            this.instrument.quoteFactor,
            this.stress,
            this.lossPrice,
            this.isPtax ? this.pTaxValue : null,
            this.secondaryStress,
        );
    }

    /**
     * Busca os dados básicos para cálculos de uma vez
     */
    public calculateResources() {
        this.lossPrice = this.calculateGainLossPrice('loss');
        this.gainPrice = this.calculateGainLossPrice('gain');
        this.fillCalculateParams();
    }

    /**
     * Redireciona para o checkout
     */
    public goToCheckout() {
        const isIdentified = this.userProfile === RolesUser.Identified;
        if (!this.isLogged || isIdentified) {
            return window.location.href = this.settingService.getConfigurationKeyValue('rau');
        }
        // tslint:disable-next-line: prefer-const
        let item = new StockCheckoutType();
        item.symbol = this.symbol;
        item.adviceId = this.stockDetails.id;
        item.category = this.categoryName;
        item.origin = TrackOriginEnum.RECOMENDATIONS;

        if (this.usingZeroModel) {
            this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item});
            this.dialogsService.showComponentAsAsidePanel(CheckoutWrapperComponent, true);
        } else if (((this.categoryName.trim()).toUpperCase()).equals('PALAVRA DO ANALISTA') && !this.isMobile) {
            StorageService.setSessionItem('stockCheckoutItem', JSON.stringify(item));
            if (item.symbol.endsWith('F')) {
                window.open(`/bolsa/checkout`);
            } else {
                window.open(`/bolsa/checkout/planejado`);
            }
        } else {
            this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item});
            if(item.symbol.endsWith('F')) {
                this.router.navigate(['/checkout']);
            } else {
                this.router.navigate(['/checkout/planejado']);
            }
        }
    }

    /**
     * Redireciona para a análise
     */
    public goToAnalyze() {
        this.router.navigateByUrl(`/oportunidade/${this.stockDetails.id}`);
    }

    /**
     * Abre o overlay com o grafico
     */
    public openGraphicOverlay() {
        this.dialogsService.showComponnent(
            DialogGraphicComponent,
            {
                name: this.instumentName,
                sticker: this.symbol,
                market: this.marketType,
                logoPath: this.instrument.logoPath,
            },
        );
    }

    /**
     * Abre o modal com dados sobre a empresa
     */
    public openAboutCompany() {
        this.dialogsService.showComponnent(
            OverlaySimpleComponent,
            {
                title: `Sobre a ${this.instumentName}`,
                content: this.aboutCompanyText,
                closeButton: 'Fechar',
            },
        );
    }

    public ngOnDestroy() {
        if (this.needQuote) {
            this.store.dispatch({type: StocksMarketAction.unsubscribeQuotes, payload: [this.symbol]});
        }
    }

    /**
     * Faz os primeiros cáclculos com os dados que recebe do stockDetails
     */
    private calculateByBase(stockDetails: ResearchAdviceLite) {
        this.unitPrice = stockDetails.instrument.unitPrice;
        this.instrument = stockDetails.instrument;
        this.logo = stockDetails.instrument.logoPath;
        this.isFuture = this.instrument.typeMarket === OrderMarketTypeEnum.Future;
        this.stress = stockDetails.instrument.stress.dayTradeStrategyValue;
        this.secondaryStress = stockDetails.instrument.stress.value;
        this.isPtax = stockDetails.instrument.stress.isPtax;
        if (this.isPtax) {
            this.store.dispatch({ type: StocksMarketAction.getQuote, payload: KeyStocks.DolPtax });
        }
        this.calculateResources();
        this.minimumPriceToInvest = this.calculateMinimumPriceToInvest();
        this.profitPotential = this.calculateProfitPotential();
    }

}
